// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__8rU1t","content":"styles_content__KTydL","profileList":"styles_profileList__d-6A2"};